import axios from 'axios'
import {ParamsModel} from '../Model'

const API_URL = window.__RUNTIME_CONFIG__.REACT_APP_API_URL

export const GET_USERS_ROLE_PERMISSION = `${API_URL}/permission/list`
export const GET_USERS_PERMISSION = `${API_URL}/login-user-permission`

export const GET_DISTRICT = `${API_URL}/district`
export const GET_MUNICIPALITY_DATA = `${API_URL}/municipality`
export const GET_PROVINCE = `${API_URL}/province`
export const GET_CATEGORY_TYPE = `${API_URL}/category-type`

export const service = {
  getPermissions: () => {
    return axios.get(GET_USERS_ROLE_PERMISSION)
  },
  getUserPermissions: () => {
    return axios.get(GET_USERS_PERMISSION)
  },
  getMunicipality: (id: string) => {
    return axios.get(`${GET_MUNICIPALITY_DATA}?districtId=${id}`)
  },

  getDistrict: (id: string) => {
    return axios.get(`${GET_DISTRICT}?provinceId=${id}`)
  },

  getProvince: () => {
    return axios.get(GET_PROVINCE)
  },
  getCategoryType: () => {
    return axios.get(GET_CATEGORY_TYPE)
  },
}
